import styled from "styled-components";

export const StyledUserManagementContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem 0 1rem;
  width: 100%;
  flex-grow: 1;
  box-sizing: border-box;
`;

export const StyledHeadline = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
  box-sizing: border-box;
  height: 50px;
`;

export const StyledUserListWrapper = styled.div`
  min-height: 200px;
  flex-grow: 1;
`;
